import PropType from "prop-types";
import { VictoryChart, VictoryAxis, VictoryBar } from "victory";
import { ControlPointPassage } from "../../../features/controlPointPassage/dataTypes";

import styles from "./AllControlPointsGraph.module.scss";
import colors from "../../../style/colors.scss";

import { useTranslate } from "../../../language/i18n";

const AllControlPointsGraph = ({ controlPointPassages }: { controlPointPassages: Array<ControlPointPassage> }) => {
  const translate = useTranslate();
  const coordinates: Array<{ x: string; y: number }> = [];

  for (const passage of controlPointPassages) {
    const indexOfControlPoint = coordinates.findIndex(coordinate => coordinate.x == passage.controlPointName);

    if (indexOfControlPoint > -1) {
      coordinates[indexOfControlPoint] = {
        x: coordinates[indexOfControlPoint].x,
        y: coordinates[indexOfControlPoint].y + 1,
      };
    } else {
      coordinates.push({ x: passage.controlPointName, y: 1 });
    }

    coordinates.sort((a, b) => a.x.localeCompare(b.x));
  }

  return coordinates.length > 0 ? (
    <div className={styles.chartContainer}>
      <VictoryChart padding={{ left: 40, right: 20, top: 20, bottom: 80 }} domainPadding={{ x: 20, y: [0, 0] }}>
        <VictoryBar
          data={coordinates}
          style={{
            labels: { fontSize: 10 },
            data: { fill: colors.primaryDark, width: 6 },
          }}
          labels={({ datum }) => datum.y}
        />
        <VictoryAxis
          style={{
            axisLabel: { fontSize: 10, padding: 20 },
            tickLabels: { fontSize: 10, padding: 5 },
          }}
          dependentAxis
          tickFormat={tick => (tick % 1 === 0 ? tick : "")}
          label={translate("NUMBER_OF_PASSAGES")}
        />
        <VictoryAxis
          style={{
            axisLabel: { fontSize: 10, padding: 20 },
            tickLabels: { fontSize: 8, padding: 3, angle: 90, textAnchor: "start", transform: "translate(5, 0)" },
          }}
          tickFormat={tick => `${tick}`}
        />
      </VictoryChart>
    </div>
  ) : null;
};

AllControlPointsGraph.propTypes = {
  controlPointPassages: PropType.array.isRequired,
};

export default AllControlPointsGraph;
